import styled from 'styled-components';

import getRgbaColor from '@utils/getRgbaColor';

const starSize = 28;

const getStar = (type, color) => {
  const fillColor = encodeURIComponent(color);

  const stars = {
    full: `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='${fillColor}' d='M3.1 11.3l3.6 3.3-1 4.6c-.1.6.1 1.2.6 1.5.2.2.5.3.8.3l.6-.1.1-.1 4.1-2.3 4.1 2.3.1.1c.5.2 1.1.2 1.5-.1.5-.3.7-.9.6-1.5l-1-4.6 1.6-1.5 1.9-1.7.1-.1c.4-.4.5-1 .3-1.5s-.6-.9-1.2-1h-.1l-4.7-.5-1.9-4.3-.1-.1c-.1-.7-.6-1-1.1-1-.5 0-1 .3-1.3.8l-.1.1-1.9 4.3-4.7.5h-.1c-.5.1-1 .5-1.2 1-.1.6 0 1.2.4 1.6z'/%3E%3C/svg%3E")`,
    outline: `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='${fillColor}' d='M16.855 20.966c-.224 0-.443-.05-.646-.146l-.104-.051-4.107-2.343-4.107 2.344-.106.053c-.488.228-1.085.174-1.521-.143-.469-.34-.701-.933-.586-1.509l.957-4.642-1.602-1.457-1.895-1.725-.078-.082c-.375-.396-.509-.97-.34-1.492.173-.524.62-.912 1.16-1.009l.102-.018 4.701-.521 1.946-4.31.06-.11c.262-.473.764-.771 1.309-.771.543 0 1.044.298 1.309.77l.06.112 1.948 4.312 4.701.521.104.017c.539.1.986.486 1.158 1.012.17.521.035 1.098-.34 1.494l-.078.078-3.498 3.184.957 4.632c.113.587-.118 1.178-.59 1.519-.252.182-.556.281-.874.281zm-8.149-6.564c-.039.182-.466 2.246-.845 4.082l3.643-2.077c.307-.175.684-.175.99 0l3.643 2.075-.849-4.104c-.071-.346.045-.705.308-.942l3.1-2.822-4.168-.461c-.351-.039-.654-.26-.801-.584l-1.728-3.821-1.726 3.821c-.146.322-.45.543-.801.584l-4.168.461 3.1 2.822c.272.246.384.617.302.966z'/%3E%3C/svg%3E")`,
  };

  return stars[type];
};

export const Rating = styled.div<{ section: string }>`
  background: ${(props) =>
    getRgbaColor(
      props.theme.colors ? props.theme.colors[props.section] : '#000000',
      0.1
    )};
  margin-right: 0.5rem;
  padding-bottom: 0.5rem;

  &:last-child {
    margin-right: 0;
  }
`;

export const Title = styled.h2`
  border-bottom: solid 2px var(--theme-color-section);
  margin: 0 1rem 1rem;
  padding: 0.5rem;
  text-align: center;
`;

export const Score = styled.div<{ section: string; score: string }>`
  background: none 0 0 repeat-x;
  background-image: ${(props) => getStar('outline', props.theme.colors?.grey2)};
  background-size: auto ${starSize}px;
  height: ${starSize}px;
  margin: 0 auto 1rem;
  position: relative;
  transform: translateX(-10px);
  width: ${starSize * 5}px;

  &:before {
    background: none 0 0 repeat-x;
    background-image: ${(props) =>
      getStar(
        'full',
        props.theme.colors ? props.theme.colors[props.section] : '#000000'
      )};
    background-size: auto ${starSize}px;
    content: ' ';
    height: ${starSize}px;
    position: absolute;
    width: ${(props) => `${parseInt(props.score, 10) * starSize}px`};
    z-index: 1;
  }
`;

export const Value = styled.div`
  font-weight: bold;
  position: absolute;
  right: ${`-${starSize / 2}px`};
  top: 50%;
  transform: translateY(-50%);
`;

export const Summary = styled.p`
  font-size: 1rem;
  margin: 0 auto;
  text-align: center;
  width: ${`${starSize * 6}px`};
`;
